// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/payment.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_money } from "../core/money_pb";

/**
 * Describes the file proto/model/financial/payment.proto.
 */
export const file_proto_model_financial_payment = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_proto_model_core_money]);

/**
 * Describes the message carmen.PaymentProviderId.
 * Use `create(PaymentProviderIdSchema)` to create a new message.
 */
export const PaymentProviderIdSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 0);

/**
 * Describes the message carmen.PaymentMethodProviderId.
 * Use `create(PaymentMethodProviderIdSchema)` to create a new message.
 */
export const PaymentMethodProviderIdSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 1);

/**
 * Describes the message carmen.PaymentMethod.
 * Use `create(PaymentMethodSchema)` to create a new message.
 */
export const PaymentMethodSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 2);

/**
 * Describes the message carmen.CardDetails.
 * Use `create(CardDetailsSchema)` to create a new message.
 */
export const CardDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 3);

/**
 * Describes the message carmen.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 4);

/**
 * Describes the message carmen.PaymentBookingLink.
 * Use `create(PaymentBookingLinkSchema)` to create a new message.
 */
export const PaymentBookingLinkSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_payment, 5);

/**
 * Describes the enum carmen.PaymentProvider.
 */
export const PaymentProviderSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_payment, 0);

/**
 * Supported payment providers
 *
 * @generated from enum carmen.PaymentProvider
 */
export const PaymentProvider = /*@__PURE__*/
  tsEnum(PaymentProviderSchema);

/**
 * Describes the enum carmen.PaymentStatus.
 */
export const PaymentStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_payment, 1);

/**
 * Status of a payment
 *
 * @generated from enum carmen.PaymentStatus
 */
export const PaymentStatus = /*@__PURE__*/
  tsEnum(PaymentStatusSchema);

/**
 * Describes the enum carmen.LinkType.
 */
export const LinkTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_payment, 2);

/**
 * Type of payment-booking relationship for atomic operations
 *
 * @generated from enum carmen.LinkType
 */
export const LinkType = /*@__PURE__*/
  tsEnum(LinkTypeSchema);

